import {
  HeadContent,
  Outlet,
  Scripts,
  createRootRouteWithContext,
} from '@tanstack/react-router'
import { TanStackRouterDevtoolsPanel } from '@tanstack/react-router-devtools'
import { TanStackDevtools } from '@tanstack/react-devtools'
import { Toaster } from '../components/ui/sonner'

import TanStackQueryDevtools from '../integrations/tanstack-query/devtools'
import { supabase } from '../auth/supabase'

import type { QueryClient } from '@tanstack/react-query'
import NotFound from '@/components/pages/NotFound'
import { seo } from '@/utils/seo'
import { DefaultCatchBoundary } from '@/components/DefaultCatchBoundary'

export interface MyRouterContext {
  queryClient: QueryClient
}

export const Route = createRootRouteWithContext<MyRouterContext>()({
  beforeLoad: async () => {
    const { data } = await supabase.auth.getSession()
    return { session: data.session }
  },
  head: () => ({
    meta: [
      {
        charSet: 'utf-8',
      },
      {
        name: 'viewport',
        content: 'width=device-width, initial-scale=1',
      },
      {
        name: 'apple-mobile-web-app-title',
        content: 'Snow Spot',
      },
      {
        name: 'theme-color',
        content: '#070a13',
      },
      ...seo({
        url: 'https://snowspot.app',
        title: 'SnowSpot | Snowfall and Forecast Tracking Tools',
        description: `Track live snowfall and forecast data for ski resorts, SNOTELs, and custom locations across North America. Sign up now and find your perfect snow spot!`,
        image: '/og-preview.png',
        keywords:
          'snow, snowfall Tracking, forecast, skiing, snowboarding, sledding, backcountry, snotel, ski, ski resort',
      }),
    ],
    links: [
      {
        rel: 'apple-touch-icon',
        sizes: '180x180',
        href: '/apple-touch-icon.png',
      },
      {
        rel: 'icon',
        type: 'image/png',
        sizes: '96x96',
        href: '/favicon-96x96.png',
      },

      {
        rel: 'icon',
        type: 'image/svg+xml',
        href: '/favicon.svg',
      },
      {
        rel: 'shortcut icon',
        href: '/favicon.ico',
      },
      { rel: 'manifest', href: '/site.webmanifest', color: '#fffff' },
      { rel: 'icon', href: '/favicon.ico' },
    ],
    scripts: [],
  }),
  errorComponent: (props) => {
    return <DefaultCatchBoundary {...props} />
  },
  notFoundComponent: () => <NotFound />,
  component: () => (
    <>
      <HeadContent />
      <Scripts />
      <Outlet />
      <Toaster />
      <TanStackDevtools
        config={{
          position: 'bottom-right',
        }}
        plugins={[
          {
            name: 'Tanstack Router',
            render: <TanStackRouterDevtoolsPanel />,
          },
          TanStackQueryDevtools,
        ]}
      />
    </>
  ),
})
